import { Filter } from '@dfl/mui-admin-layout';
import { createdATFilter } from 'modules/common/constants';
import {
  shippingAddressFilter,
  orderCodeFilter,
  orderDeliverTimeTypeFilter,
  orderEmailFilter,
  // orderOfferFilter,
  orderProductItemsFilter,
  orderTotalAmountFilter,
  orderTotalItemsFilter,
  orderTotalProductsFilter,
  paymentGatewayFilter,
  paymentMethodFilter,
  orderSupplierFilter,
} from 'modules/sales/common/constants/order-filters';

export const preOrderFilters: Filter[] = [
  orderCodeFilter,
  ...shippingAddressFilter,
  orderSupplierFilter,
  // orderStatusFilter,
  orderTotalProductsFilter,
  orderTotalAmountFilter,
  orderDeliverTimeTypeFilter,
  paymentGatewayFilter,
  paymentMethodFilter(),
  // orderPaidAtFilter,

  orderTotalItemsFilter,
  orderEmailFilter,
  // orderHasPaymentFilter,
  // orderHasChargeBackFilter,
  // orderOfferFilter,
  // orderLogisticFilter,
  // orderDeliveryStatusFilter,
  orderProductItemsFilter,
  createdATFilter,
];

export const defaultPreOrderFilterKeys: Filter[] = [
  orderCodeFilter,
  ...shippingAddressFilter,
  orderSupplierFilter,
  // orderStatusFilter,
  orderTotalProductsFilter,
  orderTotalAmountFilter,
  orderDeliverTimeTypeFilter,
  paymentGatewayFilter,
  paymentMethodFilter(),
  // orderPaidAtFilter,
];
